/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Cost_CapsInputs */

const en_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost caps`)
};

const ar_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود التكلفة`)
};

const bn_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কস্ট ক্যাপ`)
};

const de_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenobergrenzen`)
};

const es_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de costos`)
};

const fr_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plafonds de coûts`)
};

const pt_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de custo`)
};

const zh_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本上限`)
};

const tr_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet sınırları`)
};

const ru_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничение стоимости`)
};

const pl_svchip_cost_caps = /** @type {(inputs: Svchip_Cost_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity kosztów`)
};

/**
* | output |
* | --- |
* | "Cost caps" |
*
* @param {Svchip_Cost_CapsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_cost_caps = /** @type {((inputs?: Svchip_Cost_CapsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Cost_CapsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_cost_caps(inputs)
	if (locale === "bn") return bn_svchip_cost_caps(inputs)
	if (locale === "de") return de_svchip_cost_caps(inputs)
	if (locale === "es") return es_svchip_cost_caps(inputs)
	if (locale === "fr") return fr_svchip_cost_caps(inputs)
	if (locale === "pt") return pt_svchip_cost_caps(inputs)
	if (locale === "zh") return zh_svchip_cost_caps(inputs)
	if (locale === "tr") return tr_svchip_cost_caps(inputs)
	if (locale === "ru") return ru_svchip_cost_caps(inputs)
	if (locale === "pl") return pl_svchip_cost_caps(inputs)
	return en_svchip_cost_caps(inputs)
});